export enum ProductPublicationOptionEnum {
  EVERY_OWN_DIV = '1',
  SPECIFIED = '2',
  REFERENCE = '3',
  PRIVATE = '4',
}

export const ProductPublicationOption = [
  { label: '自部門の全得意先に公開する', value: ProductPublicationOptionEnum.EVERY_OWN_DIV },
  { label: '指定した得意先のみに公開する', value: ProductPublicationOptionEnum.SPECIFIED },
  { label: '商品分類1の設定を参照する', value: ProductPublicationOptionEnum.REFERENCE },
  { label: '非公開', value: ProductPublicationOptionEnum.PRIVATE },
];
